import { render, staticRenderFns } from "./Dairy.vue?vue&type=template&id=7897a647&scoped=true&"
import script from "./Dairy.vue?vue&type=script&lang=js&"
export * from "./Dairy.vue?vue&type=script&lang=js&"
import style0 from "./Dairy.vue?vue&type=style&index=0&id=7897a647&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897a647",
  null
  
)

export default component.exports